import Dexie from 'dexie';

const db = new Dexie('carcheck.records');
db.version(1).stores({
  records: '',
  // dashboard : ''
});

export default db;
